import { carousel } from "./constants";

function slideChangeTransitionEnd() {
  document
    .querySelectorAll(
      `${carousel.mainContainer} ${carousel.slideContainer} iframe`
    )
    .forEach(iframe => {
      iframe.contentWindow.location.reload();
    });
  document
    .querySelectorAll(
      `${carousel.mainContainer} ${carousel.slideContainer} video`
    )
    .forEach(video => {
      video.pause();
    });
}

function slideChangePagination() {
  const swiperElement = document.querySelector(carousel.mainContainer);

  const params = {
    injectStyles: [
      `
    .swiper-pagination {
      position: relative;
    }
    `
    ],
    pagination: {
      clickable: true,
      renderBullet(index, className) {
        return `<span class="${className}"></span>`;
      }
    }
  };

  Object.assign(swiperElement, params);

  swiperElement.initialize();
}

export default function initHandlersCarousel() {
  if (!document.querySelector(carousel.mainContainer)) {
    return;
  }
  slideChangePagination();
  document.querySelectorAll(carousel.mainContainer).forEach(swiperElement => {
    swiperElement.swiper.on(
      "slideChangeTransitionEnd",
      slideChangeTransitionEnd
    );
  });
}
